<section class="user-details center-layout">
  <div class="form-central__content" style="width: 30%">
    <div class="form-central__form item-content">
      <div class="icon-wrapper">
        <svg
          width="92"
          height="93"
          viewBox="0 0 92 93"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.10059 46.4218C6.10059 24.3857 23.9644 6.52185 46.0006 6.52185C68.0368 6.52185 85.9006 24.3857 85.9006 46.4218C85.9006 68.458 68.0368 86.3218 46.0006 86.3218C23.9644 86.3218 6.10059 68.458 6.10059 46.4218ZM65.1155 37.0368C65.6347 36.4993 65.922 35.7794 65.9155 35.0321C65.909 34.2848 65.6092 33.57 65.0808 33.0416C64.5524 32.5132 63.8376 32.2135 63.0903 32.207C62.3431 32.2005 61.6231 32.4877 61.0856 33.0069L41.7256 52.367L32.3405 42.9819C31.803 42.4627 31.0831 42.1755 30.3358 42.182C29.5886 42.1885 28.8738 42.4882 28.3454 43.0166C27.8169 43.545 27.5172 44.2598 27.5107 45.0071C27.5042 45.7544 27.7915 46.4743 28.3106 47.0118L39.7106 58.4118C40.2451 58.9461 40.9699 59.2462 41.7256 59.2462C42.4813 59.2462 43.2061 58.9461 43.7405 58.4118L65.1155 37.0368Z"
            fill="#54BE47"
            fill-opacity="0.8"
          />
        </svg>
      </div>

      <div class="mt-3">
        <h3 class="heading__4" style="text-align: center">
          Recurring payment set successfully
        </h3>
        <p style="text-align: center">
          Your next
          {{ successResponse.channel === "ACCOUNT" ? "bank account" : "card" }}
          debit of
          <b>NGN{{ successResponse.amount | number : "1.2-2" }}</b> with
          recurring fee of
          <b>NGN{{ successResponse.fee | number : "1.2-2" }}</b> will occur on
          <b>{{ successResponse.nextPaymentDate | date }}</b>
        </p>
      </div>

      <div
        class="footer"
        style="margin-top: 3rem; text-align: center; font-size: 12px"
      >
        Powered By:
        <img width="50" src="../../../assets/rexpay/ga.png" />
      </div>
    </div>
  </div>
</section>
